(function () {
  'use strict';

  if (window.DWCPolarisIconsLoaded) return;
  window.DWCPolarisIconsLoaded = true;

  var libraryPromise;

  function lightenIcon(svg) {
    if (!svg || svg.dataset.dwcLightIcon) return;
    var paths = svg.querySelectorAll('path');
    if (paths.length !== 3 || svg.getAttribute('viewBox') !== '0 0 16 16') return;
    paths[0].setAttribute('d', 'M8 4.25a.5.5 0 0 1 .5.5v3.5a.5.5 0 0 1-1 0v-3.5a.5.5 0 0 1 .5-.5');
    paths[1].setAttribute('d', 'M8.65 11a.65.65 0 1 1-1.3 0 .65.65 0 0 1 1.3 0');
    paths[2].setAttribute('d', 'M15 8a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-1 0a6 6 0 1 1-12 0 6 6 0 1 1 12 0');
    svg.dataset.dwcLightIcon = 'true';
  }

  function loadLibrary() {
    if (customElements.get('s-icon')) return Promise.resolve();
    if (libraryPromise) return libraryPromise;
    libraryPromise = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = 'https://cdn.shopify.com/shopifycloud/polaris-1.js';
      script.async = true;
      script.onload = function () {
        if (customElements.get('s-icon')) resolve();
        else reject(new Error('Polaris icon unavailable'));
      };
      script.onerror = reject;
      document.head.appendChild(script);
    });
    return libraryPromise;
  }

  function initialiseIcons() {
    var wrappers = Array.from(document.querySelectorAll('.dwc-spec-alert-icon:not([data-polaris-ready])'));
    if (!wrappers.length) return;
    wrappers.forEach(function (wrapper) {
      lightenIcon(wrapper.querySelector('.dwc-spec-alert-fallback'));
    });
    loadLibrary().then(function () {
      wrappers.forEach(function (wrapper) {
        if (!wrapper.isConnected || wrapper.dataset.polarisWatching) return;
        var icon = wrapper.querySelector('s-icon');
        if (!icon || !icon.shadowRoot) return;
        wrapper.dataset.polarisWatching = 'true';
        var observer;
        function reveal() {
          var svg = icon.shadowRoot.querySelector('svg');
          if (!svg) return;
          lightenIcon(svg);
          if (!icon.shadowRoot.querySelector('[data-dwc-icon-size]')) {
            var sizeStyle = document.createElement('style');
            sizeStyle.dataset.dwcIconSize = 'true';
            sizeStyle.textContent = '.icon.icon{inline-size:20px;block-size:20px}.icon.icon svg{width:20px;height:20px;margin:0}';
            icon.shadowRoot.appendChild(sizeStyle);
          }
          wrapper.dataset.polarisReady = 'true';
          if (observer) observer.disconnect();
        }
        observer = new MutationObserver(reveal);
        observer.observe(icon.shadowRoot, { childList: true, subtree: true });
        reveal();
      });
    }).catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseIcons, { once: true });
  } else {
    initialiseIcons();
  }
  document.addEventListener('on:variant:change', initialiseIcons);
  document.addEventListener('shopify:section:load', initialiseIcons);
})();
